import { GameFontStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameFontStyle";
import { GameStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractMessageDialogProperties } from "@lib/titan2/dist/game/view/properties/AbstractMessageDialogProperties";
import { CommonStyle } from "@lib/titan2/dist/game/view/style/CommonStyle";
import { Point } from "pixi.js";
/**
 * MessageDialogProperties.ts
 */
export class MessageDialogProperties extends AbstractMessageDialogProperties {
    constructor() {
        super();
        const imageWidth = 836;
        this.titleFieldProperties = new TextFieldProperties(GameFontStyle.MESSAGE_DIALOG_TITLE, new Point(imageWidth / 2, 40), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(750, 160));
        this.messageFieldProperties = new TextFieldProperties(GameFontStyle.MESSAGE_DIALOG_BODY, new Point(imageWidth / 2, 247), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(750, 400));
        this.messageFieldProperties.multiline = true;
        const buttonImageWidth = 419;
        this.confirmButtonProperties = new ButtonProperties(GameStyle.DIALOG_BUTTON_BLUE_BIG, CommonStyle.MODULE, new Point(imageWidth / 2 - buttonImageWidth / 2, 690));
        this.confirmButtonProperties.textFieldProperties = new TextFieldProperties(GameFontStyle.DIALOG_BUTTON_BIG, undefined, undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(200, 145));
    }
}
//# sourceMappingURL=MessageDialogProperties.js.map